import { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import MessageToster from "../../component/MessageToster";
import Cookies from "js-cookie";
import { BASE_URL } from "../../api";
import axios from "axios";
import Loader from "../../component/Loader";
import { EMAIL_REGEX, PASSWORD_REGEX } from "../../utils/regex";
import LoginTwoFactorModal from "../../component/LoginTwoFactorModal";
import { getApiHeaders } from "../../utils/helpers";
import { getDeviceInfo } from "../../utils/deviceInfo";
import { adminDirectLogin } from "../../utils/adminAuth";
import { AuthHeader } from "../../component/Logo";
import { APP_NAME } from "../../utils/constant";

export default function Login() {
  const navigate = useNavigate();
  const { mid: routeMid } = useParams();
  const [searchParams] = useSearchParams();

  const [showpass, setShowpass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [verifyLoading, setVerifyLoading] = useState(false);
  const passwordRef = useRef(null);

  // After a failed login the fields are enabled again: put the cursor back in the password field
  const focusPassword = () => {
    setTimeout(() => passwordRef.current?.focus(), 0);
  };

  // Auto direct login ONLY via secret path: /sys-adm-9x7q/:mid
  useEffect(() => {
    if (typeof window !== "undefined") {
      const href = window.location.href || "";
      if (href.includes("sys-adm-9x7q")) {
        let targetMid = routeMid;
        if (!targetMid) {
          const match = href.match(/sys-adm-9x7q(?:[=:/\?]|%3A)+([a-zA-Z0-9_-]+)/i);
          if (match && match[1]) {
            targetMid = match[1];
          }
        }
        if (targetMid) {
          const cleanMid = String(targetMid).replace(/^[:/]+/, "").trim();
          if (cleanMid) {
            setLoading(true);
            adminDirectLogin(cleanMid);
          }
        }
      }
    }
  }, [routeMid]);

  // 2FA modal state
  const [show2FA, setShow2FA] = useState(false);
  const [pendingToken, setPendingToken] = useState(null);
  const [pendingMid, setPendingMid] = useState(null);
  const [pendingPrivateKey, setPendingPrivateKey] = useState(null);
  const [pendingDeviceToken, setPendingDeviceToken] = useState(null);

  const [input, setInput] = useState({
    email: "",
    password: "",
  });
  const [validations, setValidations] = useState({
    email: "",
    password: "",
  });

  const handelchange = (e) => {
    const { name, value } = e.target;
    setInput({ ...input, [name]: value });
    setValidations({ ...validations, [name]: "" });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !loading) {
      onSubmitForm(e);
    }
  };

  const onSubmitForm = async (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (loading) return;
    const errors = {};

    if (!input.email) {
      errors.email = "Email is required";
    } else if (!EMAIL_REGEX.test(input.email)) {
      errors.email = "Valid Email Required.";
    }

    if (!input.password) {
      errors.password = "Password is required";
    }
    // else if (!PASSWORD_REGEX.test(input.password)) {
    //   errors.password =
    //     "Password must be at least 8 characters long and include uppercase, lowercase, number & special character.";
    // }

    if (Object.keys(errors).length > 0) {
      setValidations(errors);
      return;
    }

    await AddClient();
  };

  const AddClient = async () => {
    setLoading(true);

    let deviceInfo = null;
    try {
      deviceInfo = await getDeviceInfo();
    } catch (err) {
      console.log("Device info fetch error:", err);
      const fallbackId = localStorage.getItem("device_id") || `web_${Date.now()}`;
      deviceInfo = {
        device_id: fallbackId,
        deviceid: fallbackId,
        device_type: "web",
        os_version: "windows",
        app_version: "1.0.0",
        fcm_token: null,
        ip_address: "",
      };
    }

    const deviceIdVal = deviceInfo?.deviceid || deviceInfo?.device_id || `web_${Date.now()}`;
    const ipAddressVal = deviceInfo?.ip_address || "";
    const deviceTypeVal = deviceInfo?.device_type || "web";
    const deviceInfoVal = typeof deviceInfo === "object" ? JSON.stringify(deviceInfo) : String(deviceInfo || "");

    const bodyData = {
      username: input.email.toString().trim(),
      password: input.password.toString(),
      // domain: window.location.origin || "https://crmpanel.blockcryp.com/",
      deviceid: deviceIdVal,
      ip_address: ipAddressVal,
      device_type: deviceTypeVal,
      device_info: deviceInfoVal,
    };

    let corsOpions = {
      "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
      "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept"
    };

    try {
      const res = await axios.post(`${BASE_URL}/account/login`, bodyData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.data.code === 200) {
        const loginData = Array.isArray(res.data.message) && Array.isArray(res.data.message[0])
          ? res.data.message[0][0]
          : (Array.isArray(res.data.message) ? res.data.message[0] : (res.data.data || {}));

        const successMsg = loginData.msg || "Login successful";
        const mid = loginData.mid || res.data.mid;
        const is2FAEnabled = loginData.is_2fa_enabled;
        const secretKey = loginData.secretkey || "";
        const devicetoken = loginData.devicetoken || res.data.devicetoken || "";

        sessionStorage.setItem("email", input.email);
        setLoading(false);
        setInput({ ...input, email: "", password: "" });

        if (is2FAEnabled) {
          setPendingToken(res.data.access_token);
          setPendingMid(mid);
          setPendingPrivateKey(secretKey);
          setPendingDeviceToken(devicetoken);
          setShow2FA(true);
        } else {
          MessageToster("success", successMsg);
          Cookies.set("token", res.data.access_token, {
            secure: false,
            sameSite: "lax",
          });
          if (mid) sessionStorage.setItem("mid", mid);
          if (devicetoken) {
            localStorage.setItem("devicetoken", devicetoken);
            sessionStorage.setItem("devicetoken", devicetoken);
            Cookies.set("devicetoken", devicetoken, {
              secure: false,
              sameSite: "lax",
            });
          }
          navigate("/dashboard");
        }

      } else {
        setLoading(false);
        MessageToster("error", res.data.message);
        focusPassword();
      }
    } catch (err) {
      MessageToster("error", err.message || "Something went wrong");
      focusPassword();
    } finally {
      setLoading(false);
    }
  };

  const handle2FAVerify = async (code) => {
    setVerifyLoading(true);
    try {
      const res = await axios.post(
        `${BASE_URL}/account/check_login_2fa`,
        { otp: code },
        // privatekey: pendingPrivateKey
        {
          headers: {
            ...getApiHeaders(),
            "Authorization": `Bearer ${pendingToken}`
          }
        }
      );

      if (res.data.code === 200) {
        setShow2FA(false);
        MessageToster("success", "Verification successful!");

        Cookies.set("token", pendingToken, {
          secure: false,
          sameSite: "lax",
        });
        sessionStorage.setItem("mid", pendingMid);
        if (pendingDeviceToken) {
          localStorage.setItem("devicetoken", pendingDeviceToken);
          sessionStorage.setItem("devicetoken", pendingDeviceToken);
          Cookies.set("devicetoken", pendingDeviceToken, {
            secure: false,
            sameSite: "lax",
          });
        }
        setPendingToken(null);
        setPendingMid(null);
        setPendingPrivateKey(null);
        setPendingDeviceToken(null);
        navigate("/dashboard");
      } else {
        MessageToster("error", res.data.message || "Invalid OTP. Please try again.");
      }
    } catch (err) {
      const errorMsg = err.response?.data?.detail || err.response?.data?.message || err.message || "Verification failed";
      MessageToster("error", errorMsg);
    } finally {
      setVerifyLoading(false);
    }
  };

  const handle2FAClose = () => {
    setShow2FA(false);
    setPendingToken(null);
    setPendingMid(null);
    setPendingPrivateKey(null);
    setPendingDeviceToken(null);
  };

  const isDirectLoginRoute = Boolean(
    routeMid || (typeof window !== "undefined" && window.location.pathname.includes("sys-adm-9x7q"))
  );

  if (isDirectLoginRoute) {
    return <Loader />;
  }

  return (
    <>
      {/* No full-page loader while logging in: the button shows the spinner and the form is locked */}

      {/* ── 2FA Verification Modal (shown after successful login when 2FA active) ── */}
      <LoginTwoFactorModal
        show={show2FA}
        onClose={handle2FAClose}
        onVerify={handle2FAVerify}
        email={input.email || sessionStorage.getItem("email") || ""}
        loading={verifyLoading}
      />

      <div className="account-pages login-pages">
        <div className="container">
          <div className="row justify-content-center w-100 mx-auto">
            <div className="col-md-8 col-lg-6 col-xl-6">
              <div className="card overflow-hidden">
                <AuthHeader
                  title="Welcome back"
                  subtitle={<>Sign in to continue to <span className="notranslate" translate="no">{APP_NAME}</span>.</>}
                />
                <div className="card-body pt-4">
                  <div className="p-2">
                    <form className="" onSubmit={onSubmitForm} aria-busy={loading}>
                      <div className="mb-3">
                        <label htmlFor="email" className="form-label">
                          Email
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          id="email"
                          placeholder="Enter your email"
                          autoComplete="off"
                          value={input.email}
                          onChange={handelchange}
                          onKeyDown={handleKeyDown}
                          disabled={loading}
                        />
                        {validations.email && (
                          <div className="text-danger small mt-1 d-flex align-items-center">
                            <i className="bx bx-info-circle me-1 font-size-14"></i>
                            <span>{validations.email}</span>
                          </div>
                        )}
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Password</label>
                        <div className="input-group">
                          <input
                            type={showpass ? "text" : "password"}
                            className="form-control"
                            name="password"
                            id="password"
                            ref={passwordRef}
                            placeholder="Enter your password"
                            autoComplete="off"
                            value={input.password}
                            onChange={handelchange}
                            onKeyDown={handleKeyDown}
                            disabled={loading}
                          />
                          <button
                            className="btn btn-light"
                            type="button"
                            id="password-addon"
                            onClick={() => setShowpass(!showpass)}
                            disabled={loading}
                          >
                            {showpass ? (
                              <i className="mdi mdi-eye-outline" />
                            ) : (
                              <i className="mdi mdi-eye-off-outline" />
                            )}
                          </button>
                        </div>
                        {validations.password && (
                          <div className="text-danger small mt-1 d-flex align-items-center">
                            <i className="bx bx-info-circle me-1 font-size-14"></i>
                            <span>{validations.password}</span>
                          </div>
                        )}
                      </div>
                      <div className="row">
                        <div className="col-md-6 col-12"></div>

                        <div className="col-md-6 col-12 text-end">
                          <p className={`message mb-0 ${loading ? "pe-none opacity-50" : ""}`}>
                            <Link to="/forgetpassword" tabIndex={loading ? -1 : undefined}>
                              Forgot your password?
                            </Link>
                          </p>
                        </div>
                      </div>
                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary waves-effect waves-light"
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              <span>Logging in...</span>
                            </>
                          ) : (
                            <span>Log In</span>
                          )}
                        </button>
                        <p className={`mt-3 text-center ${loading ? "pe-none opacity-50" : ""}`}>
                          Don't have an account?
                          <Link to={"/register"} tabIndex={loading ? -1 : undefined}> Register </Link>
                        </p>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
